export const currentExpense = (state) => state.currentExpense
export const expenses = (state) => state.expenses
export const expenseStatus = (state) => state.expenseStatus
export const expenseTypes = (state) => state.expenseTypes
